import { instanceAuth } from "api/apiConfig"

// Paginated list of notifications (newest first), used to load older
// notifications into the Latest Updates feed.
export const notificationsFetchAPI = async data => {
  try {
    const response = await instanceAuth.get("notifications/all", {
      params: {
        ...data,
      },
    })
    return response
  } catch (error) {
    console.log("error fetching notifications data...", error)
    throw error
  }
}

// Mark every notification as read.
export const markAllNotificationsReadAPI = async () => {
  try {
    const response = await instanceAuth.put("notifications/read-all")
    return response
  } catch (error) {
    console.log("error marking all notifications as read...", error)
    throw error
  }
}
